import React from "react"
import styled from "styled-components"
import { NextButton } from "../NextButton"
import { CenterPiece, Footer } from "../styles"

const Wrap = styled.div`
  /* display: grid;
    grid-template-rows: auto 1fr;
    grid-gap: 1%;
    align-items: center;
    justify-items: center; */
`

export const OpenInNewTab = props => {
  const handleClick = () => {
    window.open(window?.location?.href, "_blank")
  }

  return (
    <Wrap>
      <CenterPiece>
        <div>
          <h1>Welcome</h1>
        </div>
        <div>
          <NextButton onClick={handleClick} children={"Open game in new tab"} />
        </div>
      </CenterPiece>
      <Footer></Footer>
    </Wrap>
  )
}
